var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCx(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0021ad",
    d: "M.7 0H54v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c8a42",
    d: "M.7 0H54v40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc639",
    d: "M27.3 24.8a4.8 4.8 0 1 0 0-9.6 4.8 4.8 0 0 0 0 9.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c8a42",
    d: "M24.4 17.8c.3.5.8 1.3 1.2 1q.5 0 .5.3a3 3 0 0 0 2.8-1.2v-.4h.3l.4-.3V17q.1-.2.2 0v.1h.5l.1-.1h.1c0 .7.2.7.1 1v.6c0 .2.5.2.3.3l-.2.4q-1 .6-.9.7l-.2.3-.4.2v1.2l-.3.7v1l-1.2-.1v-1.8c0-.7-.9-.5-1-.6l-.2-.1-.4-.1-.1.1-.6-.3h-1.2q-.3.1-.4.4l-.4-.2q.1-.4.3-.4l.4-.3.1-.6h.3v-.7l-.3-.3q0-.6.2-.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc639",
    d: "M47.5 11.9c-.2-.9-2.2-2.8-3.7-4q-.5-.2-.5.3l.5 1 .2.5v.4q.7.9.6 1 .3.6 1 1.2c.5.3 0 1.3 0 1.9q0 .4-.4.2c-1.6-1.5-3.3-1.5-4.8-2q-.8.1-.4.4 1.4 1.5 3.3 2.5l.6.4.8.6q.7.6.6.7-.2 1-.5 1.4-.5 1-.6.9c-3.1 2.1-4.8 2.7-9.8 2-.1 0-.6 0 0 .3 1.2.4 4.4 1 7.5-.4.8-.5 1.2-.3 1.8-.6l2.3-1.3c.7-.4 2.6-.8 3-1.2q1 .1 1.2-.5.2 0 .6-.4.4-.1.3-.2-.2-.4-.8-.6-.5-.3-1 0h-.6c-1 0-.9-3.2-1.2-4.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c8a42",
    d: "M49.7 17h-.3l-.1-.1v-.2h.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10.7 16.9-.7-.7-.7.6.1-.9-1-.1.9-.6-.5-.8.9.3.3-.8.4.8.9-.2-.5.8.8.5-1 .1zm2.4 7.7-.7-.5-.7.5.2-.8-.7-.5h.9l.2-.9.3.8h1l-.8.5zm-2.3 6.6-.6-.6-.7.6v-1h-.9l.8-.6-.5-.8 1 .3.3-.9.3.9.9-.3-.5.8.8.5-1 .2zm-6.1-7.8-.7-.6-.6.6v-1h-.9l.8-.6-.5-.8 1 .3.3-.9.3.9.9-.3-.5.8.8.6h-1zm11.8-2-.7-.7-.7.7v-1l-.8-.1.7-.5-.4-.8.9.2.3-.8.4.9.8-.3-.4.8.7.5-.9.2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCx);
export default __webpack_public_path__ + "static/media/cx.b8b0916a64ac6d80a9427423bd75580e.svg";
export { ForwardRef as ReactComponent };